var map = {
	"./TAGGIS-Promo-2022.pdf": 465,
	"./TAGGIS-Promo.pdf": 466
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;


//////////////////
// WEBPACK FOOTER
// ./src/assets/files ^\.\/.*$
// module id = 126
// module chunks = 3